var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1418","data-name":"Group 1418","transform":"translate(17547.5 6572.75)"},[React.createElement("line",{"id":"Line_64","data-name":"Line 64","x1":"25","transform":"translate(-17547.5 -6572)","fill":"none","stroke":"#c2ada4","strokeWidth":"1.5","key":0}),React.createElement("line",{"id":"Line_65","data-name":"Line 65","x1":"25","transform":"translate(-17547.5 -6564.41)","fill":"none","stroke":"#c2ada4","strokeWidth":"1.5","key":1}),React.createElement("line",{"id":"Line_66","data-name":"Line 66","x1":"25","transform":"translate(-17547.5 -6556.819)","fill":"none","stroke":"#c2ada4","strokeWidth":"1.5","key":2})]));
}

Menu.defaultProps = {"width":"25","height":"16.681","viewBox":"0 0 25 16.681"};

module.exports = Menu;

Menu.default = Menu;
